module.exports = __webpack_public_path__ + "img/logo-small.7fc8f85d.svg";